.app {
  padding: 0 16px;
}

.pagination {
  display: flex;
  justify-content: center;
  gap: 6px;
  margin: 16px 0;
  list-style: none;
  padding: 0;
}

.pagination li {
  width: 40px;
  height: 40px;
  border: 1px solid #ccc;
  cursor: pointer;
  border-radius: 4px;
}

.pagination a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.active {
  background-color: #0a66c2;
  color: white;
  font-weight: bold;
}
